import React from "react";
import styles from "../../assets/styles/Charge/Charge.module.scss";
import {
  MimaButton,
  MimaDropdown,
  MimaInput,
  MimaMultiPaginatedDropdown,
  MimaText,
  Modal,
  ReceiptCheckBox as RCB,
} from "../../components";
import { Formik } from "formik";

const AddCharge = ({
  closeModal,
  onSubmit,
  validationSchema,
  loading,
  currencyCodes,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={4}>
        Add New Charge
      </MimaText>
      <Formik
        initialValues={{
          name: "",
          type: "Fixed",
          minRange: 4,
          maxRange: 100000,
          value: 0,
          currencyCode: "NGN",
          businesses: [],
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <>
            <MimaMultiPaginatedDropdown
              labelTitle="Businesses(Optional)"
              name="businesses"
              id="businesses"
              value={values.businesses}
              placeholder="Select Businesses"
              currentValue={values.businesses}
              onChange={(data) => {
                setFieldValue("businesses", data);
              }}
              touched={touched.businesses}
              error={errors.businesses}
              queryKey={["getAllSignedBusinesses"]}
              optionLabel="tradingName"
              url="/businesses"
              getPageValue={(page) => page?.data?.businesses || []}
              getPageTotalCount={(lastPage) => lastPage?.data?.count || 0}
              variant="medium"
            />
            <MimaInput
              labelTitle="Charge Name"
              name="name"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.name}
              touched={touched.name}
            />

            <div className={styles.option}>
              <MimaText variant="small" mb={1}>
                Value Type
              </MimaText>
              <div className="modal__beside">
                <RCB
                  title="Fixed"
                  onChange={() => {
                    setFieldValue("type", "Fixed");
                  }}
                  checked={values.type === "Fixed"}
                  value="Fixed"
                  name="type"
                />
                <RCB
                  title="Percentage"
                  onChange={() => setFieldValue("type", "Percentage")}
                  checked={values.type === "Percentage"}
                  value="percentage"
                  name="type"
                />
              </div>
            </div>
            {values.type === "Fixed" ? (
              <>
                <MimaInput
                  labelTitle="Amount"
                  name="value"
                  value={values.value}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.value}
                  touched={touched.value}
                />
                <MimaDropdown
                  labelTitle="Currency"
                  placeholder="Select"
                  name="currencyCode"
                  data={currencyCodes}
                  value={values.currencyCode}
                  id="currencyCode"
                  onChange={(data) => {
                    setFieldValue("currencyCode", data.key);
                  }}
                  // data={data}
                  error={errors.currencyCode}
                  touched={touched.currencyCode}
                />
              </>
            ) : (
              <MimaInput
                labelTitle="Percentage"
                name="value"
                value={values.value}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.value}
                touched={touched.value}
              />
            )}

            <MimaButton
              title="Save"
              width={38}
              mt={2}
              buttonColor="var(--color-dark-4)"
              onClick={handleSubmit}
              loading={loading}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};
export default AddCharge;
